// Addresses of the old help center. Inside the app they go through
// `useHelpLink`, which leads to the in-app help center once it is switched on.
export const helpCenterLinks = {
  de: {
    home: 'https://hilfe.cleverlohn.de',
    employee: {
      socialSecurityNumber:
        'https://hilfe.cleverlohn.de/de/articles/8227292-wo-finde-ich-meine-renten-sozialversicherungsnummer',
      voluntaryHealthInsurance:
        'https://hilfe.cleverlohn.de/de/articles/10110105-freiwillige-krankenversicherung-jahresarbeitsentgeltgrenze',
      mainVsSideEmployment:
        'https://hilfe.cleverlohn.de/de/articles/10489930-die-unterschiede-hauptarbeitsverhaltnis-vs-nebenarbeitsverhaltnis',
    },
    employer: {
      companyCar:
        'https://hilfe.cleverlohn.de/de/articles/10102119-dienstwagen-welche-daten-erfasst-werden-fahrtenbuch',
      companyCarLogbook:
        'https://hilfe.cleverlohn.de/de/articles/10102119-dienstwagen-welche-daten-erfasst-werden-fahrtenbuch#h_67dfd97da9',
      certificates:
        'https://hilfe.cleverlohn.de/de/articles/16938431-arbeitsbescheinigung-digital-erstellen-so-funktioniert-s',
      dataCleanup:
        'https://hilfe.cleverlohn.de/de/collections/19773901-datenbereinigung',
    },
    general: {
      mfaAuthentication:
        'https://hilfe.cleverlohn.de/de/articles/9915179-2-faktor-authentifizierung-einrichten',
      mobileApp:
        'https://hilfe.cleverlohn.de/de/articles/9911247-cleverlohn-mobile-app-installieren',
    },
    onboarding: {
      taxAdvisors:
        'https://hilfe.cleverlohn.de/de/collections/5559553-fur-kanzleien-lohnbuchhalter-innen',
      stepUploadCompanyData: {
        ['datev-lodas']:
          'https://hilfe.cleverlohn.de/de/articles/8218082-wie-exportiere-ich-mandantenstammdaten-aus-datev-lodas',
        ['datev-lug']:
          'https://hilfe.cleverlohn.de/de/articles/8218071-wie-exportiere-ich-mandantenstammdaten-aus-datev-lohn-gehalt',
        ['addison']:
          'https://hilfe.cleverlohn.de/de/articles/8218090-wie-exportiere-ich-mandantenstammdaten-aus-addison',
      },
      stepUploadEmployeeData: {
        ['datev-lodas']:
          'https://hilfe.cleverlohn.de/de/articles/8232302-wie-exportiere-ich-personalstammdaten-aus-datev-lodas',
        ['datev-lug']:
          'https://hilfe.cleverlohn.de/de/articles/8232304-wie-exportiere-ich-personalstammdaten-aus-datev-lohn-gehalt',
        ['addison']:
          'https://hilfe.cleverlohn.de/de/articles/8232307-wie-exportiere-ich-personalstammdaten-aus-addison',
      },
      stepUploadPayrollAccounts: {
        ['datev-lodas']:
          'https://hilfe.cleverlohn.de/de/articles/8232319-wie-exportiere-ich-lohnkonten-vortragswerte-aus-datev-lodas',
        ['datev-lug']:
          'https://hilfe.cleverlohn.de/de/articles/8232323-wie-exportiere-ich-lohnkonten-vortragswerte-aus-datev-lohn-gehalt',
        ['addison']:
          'https://hilfe.cleverlohn.de/de/articles/8232326-wie-exportiere-ich-lohnkonten-vortragswerte-aus-addison',
      },
      stepUploadContributionStatements: {
        ['datev-lodas']:
          'https://hilfe.cleverlohn.de/de/articles/8232316-wie-exportiere-ich-beitragsnachweise-aus-datev-lodas',
        ['datev-lug']:
          'https://hilfe.cleverlohn.de/de/articles/8232317-wie-exportiere-ich-beitragsnachweise-aus-datev-lohn-gehalt',
        ['addison']:
          'https://hilfe.cleverlohn.de/de/articles/8232318-wie-exportiere-ich-beitragsnachweise-aus-addison',
      },
      stepUploadDLSDocuments: {
        ['datev-lodas']:
          'https://hilfe.cleverlohn.de/de/articles/8232302-wie-exportiere-ich-dls-daten-aus-datev-lodas',
        ['agenda']:
          'https://hilfe.cleverlohn.de/de/articles/9522505-wie-exportiere-ich-dls-dokumente-aus-agenda',
        ['datev-lug']:
          'https://hilfe.cleverlohn.de/de/articles/8232304-wie-exportiere-ich-dls-daten-aus-datev-lohn-gehalt',
        ['addison']:
          'https://hilfe.cleverlohn.de/de/articles/9522512-wie-exportiere-ich-dls-dokumente-aus-addison',
      },
      stepUploadPreviousMonthPayslips: {
        ['datev-lodas']:
          'https://hilfe.cleverlohn.de/de/articles/8232310-wie-exportiere-ich-lohnscheine-fur-alle-angestellten-aus-datev-lodas',
        ['datev-lug']:
          'https://hilfe.cleverlohn.de/de/articles/8232314-wie-exportiere-ich-lohnscheine-fur-alle-angestellten-aus-datev-lohn-gehalt',
        ['addison']:
          'https://hilfe.cleverlohn.de/de/articles/8232315-wie-exportiere-ich-lohnscheine-fur-alle-angestellten-aus-addison',
      },
      stepUploadAgendaBackup:
        'https://hilfe.cleverlohn.de/de/articles/8182595-wie-mache-ich-eine-datensicherung-eines-mandanten-in-agenda',
      stepUploadPaymentFile: {
        ['datev-lodas']:
          'https://hilfe.cleverlohn.de/de/articles/10311765-wie-exportiere-ich-informationen-zu-den-zahlungen-aus-datev-lodas',
        ['agenda']:
          'https://hilfe.cleverlohn.de/de/articles/9207697-wo-finde-ich-die-zahlungsdatei-oder-den-uberweisungstrager',
        ['datev-lug']:
          'https://hilfe.cleverlohn.de/de/articles/10311782-wie-exportiere-ich-eine-zahlungsubersicht-aus-datev-lohn-gehalt',
        ['addison']:
          'https://hilfe.cleverlohn.de/de/articles/9207697-wo-finde-ich-die-zahlungsdatei-oder-den-uberweisungstrager',
      },
      stepDeregistrationReasonHelp30:
        'https://hilfe.cleverlohn.de/de/articles/8238889-wie-melde-ich-angestellte-mit-grund-30-ende-einer-sv-pflichtigen-beschaftigung-ab',
    },
  },
}
